import { render, staticRenderFns } from "./travel-insurance-eligibility.vue?vue&type=template&id=12a96e9a&scoped=true"
import script from "./travel-insurance-eligibility.vue?vue&type=script&setup=true&lang=ts"
export * from "./travel-insurance-eligibility.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./travel-insurance-eligibility.vue?vue&type=style&index=0&id=12a96e9a&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a96e9a",
  null
  
)

export default component.exports